<!--
  - 时间选择：值是后台营业时间（HH:mm，存进云端的就是它），显示成实际时间（= 后台时间 + businessHourOffset）。
  - offset 为 null 时按后台时间原样显示。
  -->

<template>
  <v-select
    :value="normalizedValue"
    :dense="dense"
    :hide-details="hideDetails"
    :items="items"
    :label="label"
    :menu-props="{ offsetY: true }"
    :rules="rules"
    item-text="text"
    item-value="value"
    outlined
    @input="v => $emit('input', v)"
  />
</template>

<script>
import { businessTimeItems, normalizeHHmm } from '@/views/AadenPages/settings/reserveSetting/businessTime'

export default {
  name: 'BusinessTimeSelect',
  props: {
    value: { type: String, default: null },
    offset: { type: Number, default: null },
    label: { type: String, default: '' },
    dense: { type: Boolean, default: false },
    hideDetails: { type: [Boolean, String], default: false },
    rules: { type: Array, default: () => [] }
  },
  computed: {
    normalizedValue () {
      return normalizeHHmm(this.value)
    },
    items () {
      return businessTimeItems(this.offset, [this.value])
    }
  }
}
</script>
